module.exports = __webpack_public_path__ + "img/New PACI Flow - New-7.534b8559.png";